module.exports = __webpack_public_path__ + "static/media/projects5.31cb244b.jpg";